module.exports = __webpack_public_path__ + "static/image1.e419087b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/image1.png
// module id = 2737
// module chunks = 111930841657428